<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">WebHook</div>
            <div class="subTitulo">Faça aqui a configuração do seu webhook</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <form action="">
        <div class="row">
          <div class="col-6">
            <b-form-group label="Nome de aplicação" label-for="label-9">
              <b-form-input
                id="label-9"
                type="text"
                placeholder="Digite o nome da aplicação"
                v-model="webhook.application_name"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="URL (Tipo POST)" label-for="label-9">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text>https://</b-input-group-text>
                </template>
                <b-form-input
                  id="label-9"
                  type="text"
                  placeholder="Digite a url para envio da notificação"
                  v-model="webhook.endpoint"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Descrição" label-for="label-9">
              <b-form-input
                id="label-9"
                type="text"
                placeholder="Digite a descrição"
                v-model="webhook.description"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Evento" label-for="label-9">
              <v-select
                class="style-select"
                label="descricao"
                :options="actions"
                :reduce="(tipo) => tipo.tipo"
                :dense="true"
                v-model="webhook.action"
              ></v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-table striped hover :fields="fieldsWebhook" :items="webhooks">
              <template v-slot:cell(acao)="row">
                <div class="btn-group mb-2">
                  <button
                    v-b-tooltip.hover
                    title="Deletar"
                    type="button"
                    class="btn btn-light"
                    @click="modalDelete(row.item.id)"
                  >
                    <i class="uil uil-trash-alt"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </form>

      <div>
        <b-button variant="primary" @click="saveOrUpdate">Salvar</b-button>
      </div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja remover essa aplicação?</p>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="primary" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>

<script>
import serviceWebHook from '@/src/services/api-receituario/webhook'
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: { Layout, Loading },
  data() {
    return {
      isLoading: false,
      formato: '',
      agronomos: [],
      configuracao: {},
      webhook: {},
      idWebHook: null,
      actions: [
        {
          tipo: 'produto',
          descricao: 'produto',
        },
      ],
      fieldsWebhook: [
        {
          key: 'application_name',
          label: 'Aplicação',
        },
        {
          key: 'endpoint',
          label: 'URL de notificação',
        },
        {
          key: 'action',
          label: 'Evento',
        },
        {
          key: 'acao',
          label: '',
        },
      ],
      webhooks: [],
    }
  },
  async mounted() {
    this.findConfig()
  },

  methods: {
    findConfig() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      serviceWebHook
        .listar(token)
        .then((resposta) => {
          this.webhooks = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },

    saveOrUpdate() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      if (this.webhook.id) {
        serviceWebHook
          .update(token, this.webhook)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('WebHook Adicionado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.findConfig()
          })
          .catch((erro) => {
            this.isLoading = false
            this.$bvToast.toast(erro.response.data.message, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return
      }
      serviceWebHook
        .salvar(token, this.webhook)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('WebHook Adicionado!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.findConfig()
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
    modalDelete(item) {
      this.$bvModal.show('modal-delete')
      this.idWebHook = item
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      serviceWebHook
        .deletar(token, this.idWebHook)
        .then((reposta) => {
          this.isLoading = false
          this.idWebHook = null

          this.findConfig()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>